// extracted by mini-css-extract-plugin
module.exports = {"accordionComponentWrapper":"qS","header":"qT","accordionWrapper":"qU","accordionHeader":"qV","accordionIcon":"qW","accordionContent":"qX"};